import { Button, Drawer } from 'antd';
import { useTranslation } from 'translations/hooks';
import { MenuButton } from './menu-button';
import { DeleteOutlined, PlusOutlined, ToolOutlined } from '@ant-design/icons';

export const QuarantineDrawer = ({
  quarantineRedirection,
  repairRedirection,
  rejectRedirection,
  isOpen,
  onClose,
  isQuarantineEnabled,
}: {
  quarantineRedirection: string;
  repairRedirection: string;
  rejectRedirection: string;
  isOpen: boolean;
  onClose: () => void;
  isQuarantineEnabled: boolean;
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      className="drawer-sidebar"
      open={isOpen}
      placement="bottom"
      closable={false}
      onClose={onClose}
      size={500}
    >
      <div className="flex h-full flex-col justify-between">
        <div className="flex h-full flex-col items-center justify-between gap-8">
          <div className="flex flex-col gap-8">
            <div className="max-w-sm text-center text-lg text-blue-950">
              {t('receipt.quarantineDrawer.title')}
            </div>

            <div className="flex w-full flex-col gap-4">
              {isQuarantineEnabled && (
                <MenuButton
                  redirection={quarantineRedirection}
                  icon={<PlusOutlined className="text-sm" />}
                  message={t('receipt.quarantineDrawer.addOption')}
                />
              )}
              <MenuButton
                redirection={repairRedirection}
                icon={<ToolOutlined className="text-sm" />}
                message={t('receipt.quarantineDrawer.repairOption')}
              />
              <MenuButton
                redirection={rejectRedirection}
                icon={<DeleteOutlined className="text-sm" />}
                message={t('receipt.quarantineDrawer.rejectOption')}
              />
            </div>
          </div>

          <Button
            color="primary"
            variant="outlined"
            block
            size="large"
            onClick={onClose}
          >
            {t('common.cancel')}
          </Button>
        </div>
      </div>
    </Drawer>
  );
};
